// Price estimator — based on D.E.S Dépannage product list. Always low-end estimate.
// All prices in EUR HT.

const VOLUME_PRICES = {
  "0 à 10 m³": 49.99,
  "10 à 20 m³": 99.99,
  "20 à 30 m³": 124.99,
  "30 à 50 m³": 249.99,
  "50 à 75 m³": 349.99,
};

const VOLUME_MID_M3 = {
  "0 à 10 m³": 7,
  "10 à 20 m³": 13,
  "20 à 30 m³": 23,
  "30 à 50 m³": 38,
  "50 à 75 m³": 60,
};

// Number of workers based on volume bucket (low-end)
function workersForVolume(v) {
  if (!v) return 1;
  if (v === "0 à 10 m³") return 1;
  if (v === "10 à 20 m³" || v === "20 à 30 m³") return 2;
  return 3;
}

function parseInt0(s) {
  if (!s) return 0;
  const n = parseInt(String(s).replace(/[^\d]/g, ""), 10);
  return Number.isFinite(n) ? n : 0;
}

export function isFormComplete(d) {
  if (!d) return false;
  const requiredStrings = [
    d.nom, d.prenom, d.telephone, d.email,
    d.adresse_facturation,
    d.type_intervention,
    d.charg_rue, d.charg_cp, d.charg_ville,
    d.volume,
    d.cartons,
    d.manutention_particuliere,
  ];
  if (requiredStrings.some((x) => !x || !String(x).trim())) return false;
  if (!Array.isArray(d.objets_lourds) || d.objets_lourds.length === 0) return false;
  // Need elevator answer at chargement
  if (!d.ascenseur_chargement) return false;
  // If user filled livraison address, need elevator info too
  if ((d.liv_rue || "").trim() && !d.ascenseur_livraison) return false;
  // If manutention oui, need quantity
  if (d.manutention_particuliere === "Oui" && !d.manutention_combien) return false;
  return true;
}

export function estimatePrice(d) {
  const breakdown = [];
  let total = 0;

  const isDebarras = (d.type_intervention || "").toLowerCase().includes("débarras");
  const volMid = VOLUME_MID_M3[d.volume] || 0;

  // Volume
  if (d.volume) {
    const base = VOLUME_PRICES[d.volume];
    breakdown.push({ label: `Volume ${d.volume}`, value: base });
    total += base;
  }

  // Distance: ignoré dans le calcul (sur demande client)

  // Étages chargement (without elevator = 9.99/étage)
  const ec = parseInt0(d.etage_chargement);
  if (ec > 0 && d.ascenseur_chargement !== "Oui") {
    const v = +(ec * 9.99).toFixed(2);
    breakdown.push({ label: `Étages chargement (${ec} sans ascenseur)`, value: v });
    total += v;
  }
  // Étages livraison
  const el = parseInt0(d.etage_livraison);
  if (el > 0 && d.ascenseur_livraison !== "Oui") {
    const v = +(el * 9.99).toFixed(2);
    breakdown.push({ label: `Étages livraison (${el} sans ascenseur)`, value: v });
    total += v;
  }

  // Appareils
  const apPlus = parseInt0(d.appareils_plus_170);
  if (apPlus > 0) {
    const v = +(apPlus * 62.49).toFixed(2);
    breakdown.push({ label: `Électroménager > 1,70 m × ${apPlus}`, value: v });
    total += v;
  }
  const apMoins = parseInt0(d.appareils_moins_170);
  if (apMoins > 0) {
    const v = +(apMoins * 33.33).toFixed(2);
    breakdown.push({ label: `Électroménager < 1,70 m × ${apMoins}`, value: v });
    total += v;
  }

  // Objets fragiles
  const frag = parseInt0(d.manutention_combien);
  if (d.manutention_particuliere === "Oui" && frag > 0) {
    const v = +(frag * 15.82).toFixed(2);
    breakdown.push({ label: `Objets fragiles × ${frag}`, value: v });
    total += v;
  }

  // Main d'œuvre (low-end: 1 worker only for the day forfait)
  const workers = workersForVolume(d.volume);
  const moMin = +(workers * 39.99).toFixed(2);
  breakdown.push({ label: `Main-d'œuvre (${workers} intervenant${workers > 1 ? "s" : ""})`, value: moMin });
  total += moMin;

  // Véhicule utilitaire
  breakdown.push({ label: "Mise à disposition véhicule utilitaire", value: 39.99 });
  total += 39.99;

  // Débarras: add encombrant + déchetterie based on volume
  if (isDebarras && volMid > 0) {
    const enc = +(volMid * 29.99).toFixed(2);
    breakdown.push({ label: `Débarras encombrant × ${volMid} m³`, value: enc });
    total += enc;
    const dech = +(volMid * 24.99).toFixed(2);
    breakdown.push({ label: `Mise en déchetterie × ${volMid} m³`, value: dech });
    total += dech;
  }

  // Round DOWN to nearest 10 € for fourchette basse
  const lowEnd = Math.floor(total / 10) * 10;

  return {
    total: +total.toFixed(2),
    lowEnd,
    breakdown,
    canEstimate: !!d.volume,
  };
}
